import {useCallback, useState} from "react"
import {Link, useLocation} from "react-router-dom"
import {AuthSelector} from "../AuthSelector"
import styles from "./index.module.scss"
import logo from "../../../assets/degit.png"

export const NavBar = () => {
  const location = useLocation()
  const path = location.pathname
  const [showAuthSelector, setShowAuthSelector] = useState(false)

  const onClickRegister = useCallback(() => {
    setShowAuthSelector(true)
  }, [])

  const onCloseAuthSelector = useCallback(() => {
    setShowAuthSelector(false)
  }, [])

  return (
    <div className={styles.Container}>
      <Link to={"/"} className={styles.Logo}>
        <img src={logo} alt="DeGit Logo"/>
      </Link>

      <Link className={path === "/features" ? styles.ActiveLink : styles.Link} to={"/features"}>
        <div>Features</div>
      </Link>

      <Link className={path === "/roadmap" ? styles.ActiveLink : styles.Link} to={"/roadmap"}>
        Roadmap
      </Link>

      <button className={styles.RegisterButton}
              onClick={onClickRegister}
      >
        Register as alpha user
      </button>

      <AuthSelector open={showAuthSelector} onClose={onCloseAuthSelector}/>
    </div>
  )
}
